import { Box } from '@mui/material';
import { ReactElement } from 'react';

/**
 * Represents the props for the DropdownComponents component.
 */
type DropdownComponents = {
    setValue: React.Dispatch<React.SetStateAction<string>>;
    options: any[];
    path: string;
    innerRef: any;
    width: any;
    onKeyArrowDown: () => void;
    onKeyArrowUp: () => void;
    onNumFocus: (num: number) => void;
};

const dropdownStyle = {
    boxSizing: 'border-box',
    display: 'grid',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '20px',
    gap: '12px',
    isolation: 'isolate',
    position: 'absolute',
    width: '216px',
    // top: "5rem",
    background: '#F6F6F6',
    border: '1px solid #C9CACA',
    borderRadius: '6px',
    flex: 'none',
    order: '1',
    flexGrow: '0',
    zIndex: '1',
    maxHeight: '12rem',
    overflow: 'hidden',
    ':hover': {
        overflow: 'auto',
    },
};

const textDropdownStyle = {
    fontFamily: "'Lato'",
    fontStyle: 'normal',
    fontWeight: '900',
    fontSize: '13px',
    lineHeight: '24px',
    cursor: 'pointer',
    padding: '5px 8px',
    '&:hover': {
        backgroundColor: 'var(--side-bar-bg)',
        color: 'white',
    },
};

/**
 * Represents the DropdownComponents component.
 *
 * @param {DropdownComponentsProps} props - The component props.
 * @returns {ReactElement} - The rendered component.
 */
const DropdownComponents = ({
    setValue,
    options,
    path,
    innerRef,
    width,
    onKeyArrowDown,
    onKeyArrowUp,
    onNumFocus,
}: DropdownComponents): ReactElement => (
    <Box
        sx={{ ...dropdownStyle, width: `${width}px` }}
        ref={innerRef}
        onKeyDown={(event: any) => {
            if (event.key === 'ArrowDown') {
                if (typeof onKeyArrowDown === 'function') {
                    onKeyArrowDown();
                }
            } else if (event.key === 'ArrowUp') {
                if (typeof onKeyArrowUp === 'function') {
                    onKeyArrowUp();
                }
            }
        }}
    >
        {options.map((value, index) => (
            <Box
                tabindex="0"
                sx={textDropdownStyle}
                onClick={() => setValue(value)}
                onKeyDown={(event: any) => {
                    if (event.key === 'Enter') {
                        setValue(value);
                    }
                }}
                onFocus={() => {
                    if (typeof onNumFocus === 'function') {
                        onNumFocus(index);
                    }
                }}
            >
                {value[path]}
            </Box>
        ))}
    </Box>
);

export default DropdownComponents;
